const EventTypes = {
  DISPATCH: 'DISPATCH',
  DISCONNECT: 'DISCONNECT',
  CONNECT_SUCCESS_COMPONENT: 'CONNECT_SUCCESS_COMPONENT',
  AFTER_CONNECT: 'AFTER_CONNECT',
  CONNECT_ERROR_COMPONENT: 'CONNECT_ERROR_COMPONENT',
  CONNECT_REQUEST_COMPONENT: 'CONNECT_REQUEST_COMPONENT',
  CONNECT_SUCCESS_MODULE: 'CONNECT_SUCCESS_MODULE',
  CONNECT_ERROR_MODULE: 'CONNECT_ERROR_MODULE',
  CONNECT_REQUEST_MODULE: 'CONNECT_REQUEST_MODULE',
  MOUNTED: 'MOUNTED',
} as const;

export default EventTypes;
